<template>
  <article class="review">
    <h3 class="title">{{ review.title }}</h3>
    <div class="rating flex align-center">

      <div class="wrap">
        <div class="stars orange flex">
          <img
            v-for="(star, i) in review.rating"
            src="/images/icons/star.svg"
            :key="i"
          />
        </div>
        <div class="stars flex">
          <img
            v-for="(star, i) in 5"
            src="/images/icons/star-grey.svg"
            :key="i"
          />
        </div>
      </div>
      <img v-if="review.source === 'facebook'" src="/images/fb-review.png" alt="" />
      <img v-if="review.source === 'google'" src="/images/google-review.png" alt="" />
    </div>

    <div class="author">
      <p class="name">{{ review.author }}</p>
      <p class="date">{{ review.date }}</p>
    </div>
    <p
      class="description"
      :class="{ expanded }"
    >
      {{ review.content }}
    </p>
    <div
      class="action flex align-center"
      :class="{ expanded }"
      @click="expanded = ! expanded"
    >
      Read {{ expanded ? 'Less' : 'More' }}
      <img src="/images/icons/right-main.svg" alt="" />
    </div>
  </article>
</template>

<script>
export default {
  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      expanded: false,
    }
  },
}
</script>

<style scoped lang="scss">
.wrap { position: relative; }
.stars {
  margin-right: 10px;

  &.orange {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.description {
  max-height: 100px;
  overflow: hidden;
  // transition: all 0.2s ease;

  &.expanded {
    max-height: none;
  }
}

.action {

  img {
    display: inline-block;
    transition: all 0.2s ease;
  }
  &.expanded {
    img {
      transform: rotate(90deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ReviewSliderCard.vue